import { Component } from '@angular/core';

/**
 * Private layout for pages displayed to authorised users only
 *
 * @export
 * @class PrivateLayoutComponent
 */
@Component({
    selector: 'app-private',
    templateUrl: './private.layout.html',
    standalone: false
})
export class PrivateLayoutComponent { }
